import { Component, OnInit } from '@angular/core';
import { OnyxEvent } from '../../models/event';
import { EventStore } from '../../service/event.store';
import { MenuStore } from '../../../menus/service/menu.store';
import { SummaryRecordTypeEnum } from '../../models/summary-record-type.enum';
import { RouteUtils } from '../../utils/route-utils';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationStore } from '../../../permission/services/authentication.store';
import { FlashMessagesService } from '../../../shared/flash-messages/service/flash.messages.service';
import { EventUtils } from '../../utils/event-utils';
import { PartyType } from 'app/event/models/party-type';
import { Party } from 'app/event/models/party';

@Component({
  selector: 'pioneer-vendor-overview-page',
  templateUrl: './vendor-overview-page.component.html'
})
export class VendorOverviewComponent implements OnInit {

  public onyxEvent: OnyxEvent;

  public headerRecordType: SummaryRecordTypeEnum;

  public total: string;

  constructor(private eventStore: EventStore,
              private menuStore: MenuStore,
              private route: ActivatedRoute,
              private authenticationSore: AuthenticationStore,
              private flashMessagesService: FlashMessagesService) {

  }

  ngOnInit() {
    this.eventStore.selectedEvent.subscribe(event => this.onyxEvent = event);
    if (this.onyxEvent) {
      this.menuStore.setPageHeader(EventUtils.getEventName(this.onyxEvent, this.authenticationSore.isAgencyUser()),
        this.onyxEvent.eventProperty.subscriber);
    }

    // If the event property is subscribed, reservations are retrieved to build the overview.
    // Otherwise, RSVPs are
    if (this.onlySubscribers(this.onyxEvent)) {
      this.headerRecordType = SummaryRecordTypeEnum.RESERVATION;
    } else if (this.onlyNonSubscriber(this.onyxEvent)) {
      this.headerRecordType = SummaryRecordTypeEnum.RSVP;
    } else {
      this.headerRecordType = SummaryRecordTypeEnum.RESERVATION_RSVP;
    }

    this.total = 'total';

    // toggle page to editable if the URL ends with "edit" (it will default to read only)
    // otherwise, check if we need to show a warning flash message when in view modeFD
    RouteUtils.getLastUrlSegment(this.route)
      .subscribe(lastSegment => {
        if (this.authenticationSore.hasPermission('EditEvent') && !this.isEventValid()) {
          this.flashMessagesService.warn('EVENT.EVENT_MISSING_INFO',
            null,
            { hrefValue: `/#/event/${this.onyxEvent.eventId}/summary/edit` });
        }
      });

  }

  isEventValid(): boolean {
    return EventUtils.isEventValid(this.onyxEvent, this.authenticationSore.isAgencyUser());
  }

  getEventProperties() {
    return this.onyxEvent.eventVendors.filter(vendor => vendor.partyType === PartyType.PROPERTY && vendor.payorType === 'PROPERTY');
  }

  showTotalSummary() {
    return this.getEventProperties().length > 1;
  }

  private checkMoreThanOneVendorExpanded() {
    let expanded = false;

    this.getEventProperties().forEach(function (party) {
      if (!expanded && party.isExpanded) {
        expanded = true;
      } else if (expanded) {
        party.isExpanded = false;
      }
    });
  }

  private onlySubscribers(event: OnyxEvent): boolean {
    const subscriberProperties = this.getSubscribers(event);
    const nonSubscriberProperties = this.getNonSubscribers(event);
    return subscriberProperties && subscriberProperties.length > 0 && (!nonSubscriberProperties || nonSubscriberProperties.length === 0);
  }

  private onlyNonSubscriber(event: OnyxEvent): boolean {
    const subscriberProperties = this.getSubscribers(event);
    const nonSubscriberProperties = this.getNonSubscribers(event);
    return nonSubscriberProperties && nonSubscriberProperties.length > 0 && (!subscriberProperties || subscriberProperties.length === 0);
  }

  private getSubscribers(event: OnyxEvent): Party[] {
    return event.eventVendors
    .filter(vendor => vendor.partyType === PartyType.PROPERTY && vendor.payorType === 'PROPERTY' && vendor.subscriber);
  }

  private getNonSubscribers(event: OnyxEvent): Party[] {
    return event.eventVendors
    .filter(vendor => vendor.partyType === PartyType.PROPERTY && vendor.payorType === 'PROPERTY' && !vendor.subscriber);
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/overview/vendor-overview-page/vendor-overview-page.component.ts